import type { Pattern, PatternCell } from '../types';
import type { RhythmPattern } from './rhythmPattern';

export function rhythmToMelodyPattern(pattern: RhythmPattern): Pattern {
  return {
    beatsPerMeasure: pattern.beatsPerMeasure,
    measures: pattern.measures.map((m) => ({
      slots: m.slots.map((s) => ({
        ...s,
        cells: s.cells.map(
          (c): PatternCell => ({ note: c.hit ? 'do' : 'rest' }),
        ),
      })),
    })),
  };
}
